// src/components/MainLayout.js
import React from 'react';
import { Routes, Route, Link, Navigate, useNavigate } from 'react-router-dom';
import Vehiculo from '../pages/Vehiculo';
import Ajustes from '../pages/Ajustes';
import VistaPrincipal from '../pages/VistaPrincipal';
import LugarTuristico from '../pages/LugaresAdmin';
import Hospedaje from '../pages/Airbnb';
import Rentas from '../pages/Rentas';
import Login from '../pages/Login';

function MainLayout() {
  const navigate = useNavigate();
  const logeado = localStorage.getItem('logeado') === 'true';

  const handleLogout = () => {
    localStorage.removeItem('logeado');
    document.body.classList.remove('layout-menu-expanded');
    navigate('/login');
  };

  // Cierra el sidebar en móvil
  const closeMenu = () => {
    document.body.classList.remove('layout-menu-expanded');
  };

  // Si no está autenticado, sólo muestro el login
  if (!logeado) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    );
  }

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        {/* Sidebar */}
        <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme">
          <div className="app-brand demo">
            <Link to="/vehiculo" className="app-brand-link" onClick={closeMenu}>
              <span className="app-brand-logo demo">{/* SVG logo aquí */}</span>
              {/* Texto de marca más pequeño con fs-6 */}
              <span className="app-brand-text demo menu-text fw-bold ms-2 fs-6">
                Jsgraceinvestmentsllc
              </span>
            </Link>
            <a href="#!" className="layout-menu-toggle menu-link text-large ms-auto">
              <i className="bx bx-chevron-left bx-sm d-flex align-items-center justify-content-center" />
            </a>
          </div>
          <div className="menu-inner-shadow" />
          <ul className="menu-inner py-1">
            <li className="menu-item">
              <Link to="/vehiculo" className="menu-link" onClick={closeMenu}>
                <i className="menu-icon tf-icons bx bx-car" />
                <div className="text-truncate">Vehiculo</div>
              </Link>
            </li>
            <li className="menu-item">
              <Link to="/ajustes" className="menu-link" onClick={closeMenu}>
                <i className="menu-icon tf-icons bx bx-cog" />
                <div className="text-truncate">Ajustes</div>
              </Link>
            </li>
            <li className="menu-item">
              <Link to="/vista-principal" className="menu-link" onClick={closeMenu}>
                <i className="menu-icon tf-icons bx bx-spreadsheet" />
                <div className="text-truncate">Vista principal</div>
              </Link>
            </li>
            <li className="menu-item">
              <Link to="/lugar-turistico" className="menu-link" onClick={closeMenu}>
                <i className="menu-icon tf-icons bx bx-map-pin" />
                <div className="text-truncate">Lugares Turisticos</div>
              </Link>
            </li>
            <li className="menu-item">
              <Link to="/hospedaje" className="menu-link" onClick={closeMenu}>
                <i className="menu-icon tf-icons bx bx-home-alt" />
                <div className="text-truncate">Hospedaje</div>
              </Link>
            </li>
            <li className="menu-item">
              <Link to="/rentas" className="menu-link" onClick={closeMenu}>
                <i className="menu-icon tf-icons bx bx-bar-chart-alt" />
                <div className="text-truncate">Rentas</div>
              </Link>
            </li>
            <li className="menu-item">
              <button className="menu-link btn btn-link text-start" onClick={handleLogout}>
                <i className="menu-icon tf-icons bx bx-log-out" />
                <div className="text-truncate">Log Out</div>
              </button>
            </li>
          </ul>
        </aside>

        {/* Page wrapper */}
        <div className="layout-page">
          {/* Navbar */}
          <nav
            className="layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme"
            id="layout-navbar"
          >
            {/* Toggle para móvil */}
            <div className="layout-menu-toggle navbar-nav d-xl-none align-items-center me-3">
              <button
                type="button"
                className="nav-item nav-link p-0 layout-menu-toggle"
                onClick={() => {
                  document.body.classList.toggle('layout-menu-expanded');
                }}
              >
                <i className="bx bx-menu bx-sm" />
              </button>
            </div>
          </nav>

          {/* Content */}
          <div className="content-wrapper">
            <Routes>
              <Route path="/vehiculo" element={<Vehiculo />} />
              <Route path="/ajustes" element={<Ajustes />} />
              <Route path="/vista-principal" element={<VistaPrincipal />} />
              <Route path="/lugar-turistico" element={<LugarTuristico />} />
              <Route path="/hospedaje" element={<Hospedaje />} />
              <Route path="/rentas" element={<Rentas />} />
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<Navigate to="/rentas" />} />
              <Route path="*" element={<Navigate to="/rentas" />} />
            </Routes>

            {/* Footer */}
            <footer className="content-footer footer bg-footer-theme">
              <div className="container-xxl">
                <div className="footer-container d-flex align-items-center justify-content-between py-4 flex-md-row flex-column">
                  <div className="text-body">
                    © {new Date().getFullYear()}, made with ❤️ by Segos;
                    <a
                      href="https://themeselection.com"
                      target="_blank"
                      rel="noreferrer"
                      className="footer-link"
                    >
                      ThemeSelection
                    </a>
                  </div>
                  <div className="d-none d-lg-inline-block">
                    <a
                      href="https://demos.themeselection.com/sneat-bootstrap-html-admin-template/documentation/"
                      target="_blank"
                      rel="noreferrer"
                      className="footer-link me-4"
                    >
                      Documentation
                    </a>
                  </div>
                </div>
              </div>
            </footer>

            <div className="content-backdrop fade" />
          </div>
        </div>
      </div>

      {/* Overlay que cierra el menú al hacer clic fuera */}
      <div className="layout-overlay layout-menu-toggle" onClick={closeMenu} />
      <div className="drag-target" />
    </div>
  );
}

export default MainLayout;
